import React, { useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import i18n from 'rcx_i18n';

import {
    StyledErrorPageContainer,
    StyledErrorPageText,
    StyledSignOutButton,
    StyledContent,
    StyledLogo,
    StyledTryAgainButton,
    StyledLoading,
} from './index.styled';
import Logo from '../../assets/images/logo.svg';
import RemoveField from '../../assets/images/remove-field.svg';

type ErrorPageProps = {
    handleSignOutClick: () => void;
    handleTryAgainClick: () => void;
};

const ErrorPage = ({ handleSignOutClick, handleTryAgainClick }: ErrorPageProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const onSignOutButtonClick = () => {
        handleSignOutClick();
        setIsLoading(true);
    };
    return (
        <StyledErrorPageContainer>
            {isLoading && (
                <StyledLoading>
                    <CircularProgress size={24} />
                </StyledLoading>
            )}
            <StyledLogo>
                <img src={Logo} alt='RingCX Logo' />
            </StyledLogo>
            <StyledContent>
                <img src={RemoveField} alt='Error Icon' />
                <StyledErrorPageText>{i18n.t('error_page_text')}</StyledErrorPageText>
            </StyledContent>
            <StyledTryAgainButton onClick={handleTryAgainClick}>{i18n.t('try_again')}</StyledTryAgainButton>
            <StyledSignOutButton onClick={onSignOutButtonClick}>{i18n.t('sign_out')}</StyledSignOutButton>
        </StyledErrorPageContainer>
    );
};

export default ErrorPage;
